import React, { useState } from 'react';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import CreateUser from '../CreateUser';
import UserDisplay from '../UserDisplay';

const VerifiedUsers = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');

    const toggleCanvas = () => {
        setIsOpen(!isOpen);
        setRefreshKey(prevKey => prevKey + 1);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
        <div>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h2>Verified Users</h2>
                <div className='d-flex align-items-center justify-content-end'>
                    <div className="me-3">
                        <input
                            type="text"
                            className="form-control w-300px rounded-50 ps-3"
                            style={{ height: '50px' }}
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary rounded-pill px-5"
                        onClick={toggleCanvas}
                        style={{
                            height: '50px',
                            fontWeight: '600',
                            border: 'none',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                        }}
                    >
                        Create User
                    </button>
                </div>
            </div>

            <UserDisplay 
                key={refreshKey} 
                searchQuery={searchQuery} 
                status="verified"
            />

            <Offcanvas isOpen={isOpen} toggle={toggleCanvas} className="custom-canvas-width" direction='end'>
                <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleCanvas}>
                    <span className='font-weight-bold'>Create User</span>
                </OffcanvasHeader>
                <OffcanvasBody>
                    <CreateUser />
                </OffcanvasBody>
            </Offcanvas>
        </div>
    );
};

export default VerifiedUsers;

